<script setup lang="ts">
import Loading from '@/components/ui/Loading.vue';

defineProps<{
  actionType: string;
}>();
</script>

<template>
  <div class="flex flex-col items-center justify-center py-12">
    <Loading class="mb-4 h-8 w-8" />
    <p class="text-sm text-gray-600">Handling {{ actionType }}...</p>
  </div>
</template>
